import React from "react";
import { Outlet } from "react-router-dom";
import { useTranslation } from "react-i18next";

const LOGO = "https://dvsdkst7yiljv.cloudfront.net/sit-logo.png";
export const PRIVACY_EMAIL = "privacy@sportsimpact.tech";

/**
 * Page frame for the public pages parents reach from a link (team invite,
 * private consent link): a slim top bar and a wide content area, unlike the
 * narrow sign-in card. Pages choose their own width inside it.
 */
export default function JoinLayout() {
  const { t } = useTranslation();
  return (
    <div className="min-h-screen bg-[#F8F9FA]">
      <div
        aria-hidden="true"
        className="pointer-events-none absolute inset-x-0 top-0 h-80"
        style={{
          background:
            "radial-gradient(ellipse at top left, rgba(232,133,74,0.18) 0%, rgba(232,133,74,0) 60%)",
        }}
      />
      <header className="relative border-b border-[#EEF0F2] bg-white/80 backdrop-blur">
        <div className="mx-auto flex h-16 max-w-6xl items-center justify-between px-4 sm:px-6">
          <img
            src={LOGO}
            alt="Sports Impact Technologies"
            className="h-9 w-auto"
          />
          <a
            href={`mailto:${PRIVACY_EMAIL}`}
            className="hidden text-sm text-[#6B7280] transition-colors hover:text-[#111827] sm:block"
          >
            {t("auth.joinLayout.questions", { email: PRIVACY_EMAIL })}
          </a>
        </div>
      </header>
      <main className="relative mx-auto w-full max-w-6xl px-4 py-8 sm:px-6 lg:py-14">
        <Outlet />
      </main>
    </div>
  );
}

/** A centred card for short states (loading, link not working, done). */
export function StatusCard({ children }) {
  return (
    <div className="mx-auto max-w-lg rounded-2xl border border-[#EEF0F2] bg-white p-8 shadow-sm sm:p-10">
      {children}
    </div>
  );
}
